const style = (theme) => {
  const output = {
    root: {
    },
    slides: {
      display: 'flex',
      userSelect: 'none',
      '-webkit-touch-callout': 'none',
      '-khtml-user-select': 'none',
      '-webkit-tap-highlight-color': 'transparent',
      marginLeft: -10,
    },
    // carousel: {
    //   '& .slick-dots': {
    //     extend: theme.smallWrapper,
    //     position: 'absolute',
    //     width: '100%',
    //     bottom: -30,
    //     '& > *:not(:last-child)': {
    //       marginRight: 6,
    //     },
    //     '& li': {
    //       width: 20,
    //       height: 20,
    //       display: 'inline-block',
    //       '& button': {
    //         cursor: 'pointer',
    //         fontSize: 0,
    //         position: 'relative',
    //         zIndex: 1,
    //         '&::before': {
    //           content: '""',
    //           display: 'block',
    //           width: 20,
    //           height: 20,
    //           backgroundColor: theme.colors[1],
    //           border: `1px solid ${theme.getRgba(theme.colors[0], 0.2)}`,
    //           borderRadius: '50%',
    //           opacity: 1,
    //         },
    //         '&::after': {
    //           content: '""',
    //           display: 'block',
    //           width: 12,
    //           height: 12,
    //           backgroundColor: theme.colors[4],
    //           transition: `all 0.2s ${theme.easings['power4.out']}`,
    //           borderRadius: '50%',
    //           opacity: 0,
    //           position: 'absolute',
    //           zIndex: 1,
    //           top: 'calc(50% - 6px)',
    //           left: 'calc(50% - 6px)',
    //         },
    //       },
    //       '&.slick-active': {
    //         '& button': {
    //           '&::after': {
    //             opacity: 1,
    //           },
    //         },
    //       },
    //     },
    //   },
    //   '& .slick-arrow': {
    //     width: 48,
    //     height: 48,
    //     backgroundColor: theme.colors[1],
    //     borderRadius: '50%',
    //     cursor: 'pointer',
    //     position: 'absolute',
    //     top: '50%',
    //     transform: 'translateY(-50%)',
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     transition: `all 0.75s ${theme.easings.garret}`,
    //     '& .arrow': {
    //       width: 0,
    //       height: 0,
    //       borderStyle: 'solid',
    //       borderWidth: '3.5px 4px 3.5px 0',
    //       borderColor: `transparent ${theme.colors[3]} transparent transparent`,
    //       display: 'inline-block',
    //     },
    //     '&.slick-prev': {
    //       left: 0,
    //     },
    //     '&.slick-next': {
    //       right: 0,
    //       '& .arrow': {
    //         borderWidth: '3.5px 0 3.5px 4px',
    //         borderColor: `transparent transparent transparent ${theme.colors[3]}`,
    //       },
    //     },
    //     '&:hover': {
    //       backgroundColor: theme.getRgba(theme.colors[1], 0.8),
    //     },
    //   },
    //   '& .slick-track': {
    //     display: 'flex',
    //   },
    //   '& .slick-active': {
    //     '& $carouselItem': {
    //       opacity: 1,
    //     },
    //   },
    // },
    // slick: {
    //   position: 'relative',
    // },
    carouselItem: {
      position: 'relative',
      minWidth: '100%',
      paddingLeft: 10,
    },
    carouselImg: {
      overflow: 'hidden',
      position: 'relative',
      paddingBottom: '100%',
      zIndex: 1,
      marginBottom: 50,
      '& img': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    carouselText: {
      extend: theme.smallWrapper,
      '& h3': {
        fontFamily: theme.fonts[1],
        color: theme.colors[4],
        fontSize: 50,
        lineHeight: 1,
        fontWeight: 300,
      },
      '& p': {
        marginTop: 20,
        color: theme.colors[3],
        fontSize: 16,
        fontWeight: 400,
      },
    },
    dots: {
      extend: theme.smallWrapper,
      width: '100%',
      marginTop: 30,
      '& > *:not(:last-child)': {
        marginRight: 6,
      },
    },
    dot: {
      position: 'relative',
      zIndex: 1,
      width: 20,
      height: 20,
      display: 'inline-block',
      '&::before': {
        content: '""',
        display: 'block',
        width: 20,
        height: 20,
        backgroundColor: theme.colors[1],
        border: `1px solid ${theme.getRgba(theme.colors[0], 0.2)}`,
        borderRadius: '50%',
        opacity: 1,
      },
      '&::after': {
        content: '""',
        display: 'block',
        width: 12,
        height: 12,
        backgroundColor: theme.colors[4],
        transition: `all 0.2s ${theme.easings['power4.out']}`,
        borderRadius: '50%',
        opacity: 0,
        position: 'absolute',
        zIndex: 1,
        top: 'calc(50% - 6px)',
        left: 'calc(50% - 6px)',
      },
    },
    dotActive: {
      '&::after': {
        opacity: 1,
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {}

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {}

  return output
}

export default style
